import RugCardContent from './RugCardContent'
export default RugCardContent
